import * as z from 'zod'

// Type for Zod refinement context with form data
export type FormContext = { data?: { start_time?: Date } }

// Form schema
export const meetupSchema = z.object({
  title: z.string().min(3, 'Title must be at least 3 characters'),
  description: z.string().optional(),
  location: z.string().optional(),
  address: z.string().optional(),
  start_time: z.date({
    required_error: 'Start date and time is required',
    invalid_type_error: 'Start date and time must be valid',
  }),
  end_time: z
    .date({
      required_error: 'End date and time is required',
      invalid_type_error: 'End date and time must be valid',
    })
    .superRefine((end_time, ctx: z.RefinementCtx & FormContext) => {
      if (!ctx.data?.start_time) return
      const start = ctx.data.start_time
      if (!(end_time > start)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'End time must be after start time',
        })
      }
    }),
  signup_start_time: z.date().optional(),
  is_private: z.boolean().default(false),
  add_placeholders: z.boolean().default(true),
  status: z.string().default('draft'),
  limit_time_range: z.boolean().default(false),
  daily_start_time: z.string().optional(),
  daily_end_time: z.string().optional(),
})

export type MeetupFormValues = z.infer<typeof meetupSchema>
